<template>
  <div class="loot__list">
    <div
      v-for="(item, index) in itemsList"
      :key="index"
      :name="getTooltipName(item, index)"
      :class="activeClass(index)"
      @click="changeActiveItem(index)"
    >
      <img :src="getItemImage(item)" :alt="item.reward.title" />
      <tippy
        :to="getTooltipName(item, index)"
        theme="wf-bp access-list"
        :arrow="false"
        :duration="0"
      >
        <p>{{ item.title }} ({{ itemDuration(item.reward).text }})</p>
      </tippy>
    </div>
  </div>
</template>

<script>
import ItemDurationMixin from "../../Common/ItemDurationMixin";

export default {
  name: "LootList",

  mixins: [ItemDurationMixin],

  props: {
    itemsList: Array,
    currentIndex: Number,
  },

  methods: {
    activeClass(index) {
      return ["loot__item", { active: this.currentIndex === index }];
    },
    getItemImage(item) {
      let image_id = item.reward.item.achievement
        ? `achive_${item.reward.item.id}`
        : item.reward.item.id;
      return `https://wf.cdn.gmru.net/static/wf.mail.ru/img/main/items/${image_id}.png`;
    },
    changeActiveItem(index) {
      this.$emit("changeActiveItem", index);
    },
    getTooltipName(item, index) {
      return `reward_tooltip-${item.reward.item.id}_${index}`;
    },
  },
};
</script>
